// extracted by mini-css-extract-plugin
module.exports = {"view":"MaintenanceView_view__1iCUI","backgroundVideo":"MaintenanceView_backgroundVideo__2e1J5","content":"MaintenanceView_content__3vced","window":"MaintenanceView_window__1RAb-"};